import { type ReactNode } from 'react'
import { IconButton } from 'shared/ui'
import { mobilePreviewModal } from './actions/mobilePreviewModal'

export type IMobilePreviewProps = {
  children: ReactNode
  tooltipLabel?: string
}

export const MobilePreview = ({
  children,
  tooltipLabel = 'Message preview',
}: IMobilePreviewProps) => {
  const onMobilePreview = () => {
    mobilePreviewModal(children)
  }

  return (
    <IconButton
      ariaLabel={'mobilePreviewBtn'}
      icon={'lineInfoCircle'}
      variant={'icon'}
      color={'secondary'}
      onClick={onMobilePreview}
      tooltipProps={{
        label: tooltipLabel,
        placement: 'bottom-end',
      }}
    />
  )
}
